import SwitchBranchContext from '@aurora/shared-client/components/context/SwitchBranchContext/SwitchBranchContext';
import TenantContext from '@aurora/shared-client/components/context/TenantContext';
import type { ComponentScriptGroups } from '@aurora/shared-generated/types/graphql-schema-types';
import { PageScriptGroup } from '@aurora/shared-generated/types/graphql-schema-types';
import Script from 'next/script';
import React, { useContext } from 'react';
import { getComponentScriptTagGroups } from '../../context/ScriptsContext/ComponentScriptsProvider';

interface Props {
  /**
   * The script group tag to be fetched
   */
  scriptGroups: ComponentScriptGroups;
}

const CustomComponentScripts: React.FC<React.PropsWithChildren<Props>> = ({ scriptGroups }) => {
  const tenant = useContext(TenantContext);
  const { branchName } = useContext(SwitchBranchContext);
  const scriptGroupsTag = getComponentScriptTagGroups(tenant, branchName, scriptGroups);

  return (
    <React.Fragment>
      {scriptGroupsTag[PageScriptGroup.AfterInteractive]?.map(({ id, src }) => (
        <Script id={id} key={id} src={src} strategy={'afterInteractive'} />
      ))}
      {scriptGroupsTag[PageScriptGroup.LazyOnLoad]?.map(({ id, src }) => (
        <Script id={id} key={id} src={src} strategy={'lazyOnload'} />
      ))}
    </React.Fragment>
  );
};

export default CustomComponentScripts;
